export const getSpeakerOutlineOptions = (speakers, speakerId, allOutlines = []) => {
  if (!speakerId) return allOutlines;
  return speakers.find((speaker) => String(speaker.id) === String(speakerId))?.outlines || [];
};

export const getOtherOutlineOptions = (speakerOutlines = [], allOutlines = []) => {
  const assignedIds = new Set((speakerOutlines || []).map((outline) => String(outline.id)));
  return (allOutlines || []).filter((outline) => !assignedIds.has(String(outline.id)));
};

export const filterAndSortSpeakers = ({
  speakers = [],
  activeCongregationId,
  direction = "incoming",
  query = "",
  sort = "default",
}) => {
  const normalizedQuery = query.trim().toLocaleLowerCase("it");
  const filtered = speakers.filter((speaker) => {
    const isInternal = Number(speaker.congregazione_origine_id) === Number(activeCongregationId);
    if (direction === "outgoing" ? !isInternal : isInternal) return false;
    const outlineSearchText = (speaker.outlines || [])
      .map((outline) => `${outline.numero || ""} ${outline.titolo || ""}`)
      .join(" ");
    return !normalizedQuery ||
      `${speaker.nome} ${speaker.cognome} ${speaker.congregazione_origine} ${outlineSearchText} ${speaker.email || ""} ${speaker.telefono || ""}`
        .toLocaleLowerCase("it")
        .includes(normalizedQuery);
  });

  const byDefault = (left, right) =>
    `${left.congregazione_origine} ${left.cognome} ${left.nome}`.localeCompare(
      `${right.congregazione_origine} ${right.cognome} ${right.nome}`,
      "it",
      { sensitivity: "base" }
    );
  const byAlphabetical = (left, right) =>
    `${left.cognome || ""} ${left.nome || ""} ${left.congregazione_origine || ""}`.localeCompare(
      `${right.cognome || ""} ${right.nome || ""} ${right.congregazione_origine || ""}`,
      "it",
      { sensitivity: "base" }
    );

  return [...filtered].sort((left, right) => {
    if (sort === "alphabetical") return byAlphabetical(left, right);

    const leftNever = Number(left.history_count || 0) === 0;
    const rightNever = Number(right.history_count || 0) === 0;
    if (sort === "never_first" && leftNever !== rightNever) return leftNever ? -1 : 1;
    if (sort === "oldest_first" || sort === "never_first") {
      if (leftNever !== rightNever) return leftNever ? -1 : 1;
      const dateOrder = String(left.ultima_attivita || "").localeCompare(String(right.ultima_attivita || ""));
      if (dateOrder) return dateOrder;
    }
    if (sort === "recent_first") {
      if (leftNever !== rightNever) return leftNever ? 1 : -1;
      const dateOrder = String(right.ultima_attivita || "").localeCompare(String(left.ultima_attivita || ""));
      if (dateOrder) return dateOrder;
    }
    return byDefault(left, right);
  });
};
